import { useHotkeys } from 'react-hotkeys-hook';

import { type Clip } from '@air/api/types';
import { getVideoFps } from '@air/utils-video';

import { usePlayerStore } from '../components/PlayerContextProvider';
import { usePlayerPause } from './usePlayerPause';

export type UsePlayerFrameShortcutParams = {
  clip: Clip;
  /**
   * The scope for the frame shortcut.
   * @see https://github.com/JohannesKlauss/react-hotkeys-hook?tab=readme-ov-file#scopes
   */
  scope: string;
};

export const usePlayerFrameShortcut = ({ clip, scope }: UsePlayerFrameShortcutParams) => {
  const initialized = usePlayerStore((store) => store.initialized);
  const videoElement = usePlayerStore((store) => store.videoElement);
  const { onPlayerPause } = usePlayerPause();

  useHotkeys(
    'shift+left,shift+right',
    ({ key }) => {
      const fps = getVideoFps(clip);
      const framesInSeconds = 1 / fps;

      if (videoElement) {
        if (!videoElement.paused) {
          onPlayerPause();
        }

        videoElement.currentTime += key === 'ArrowLeft' ? -framesInSeconds : framesInSeconds;
      }
    },
    {
      description: 'Seek to a specific frame of the video',
      enabled: initialized && videoElement !== null,
      preventDefault: true,
      scopes: [scope],
    },
    [clip, videoElement, scope],
  );
};
